
const digest = 'dae4f6f0e87a7b4ba23952a87a84c8aa3ec17ed9b555a236508190b6e2f0f1d8';
const classes = {"formText":"_formText_1g3dt_1","hintText":"_hintText_1g3dt_7"};
const css = `._formText_1g3dt_1 {
  font-size: 16px;
  font-weight: 500;
  margin: 16px 0 8px 0;
}

._hintText_1g3dt_7 {
  font-size: 14px;
  justify-content: center;
  display: flex;
  margin-bottom: 7px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  